import { picoapp } from 'picoapp'
import { components, state } from '@/components'
import { toSnakeCase } from '@/lib/string'

const componentFunctions = {}

components.forEach(c => {
    const name = c.name ? c.name: c
    const file = c.file ? c.file: toSnakeCase(c)
    const func = require(`@/components/${file}`).default

    componentFunctions[name] = func
})

export default picoapp(componentFunctions, state)